export interface ServiceTerritory {
  name: string;
  prefixes: string[];
}

const split = (value: string): string[] => value.split(/\s+/);

export const SERVICE_TERRITORIES: ServiceTerritory[] = [
  { name: "Hamilton / Ancaster / Dundas / Stoney Creek / Waterdown", prefixes: split("L8B L8E L8G L8H L8J L8K L8L L8M L8N L8P L8R L8S L8T L8V L8W L9A L9B L9C L9G L9H L9K") },
  { name: "Burlington", prefixes: split("L7L L7M L7N L7P L7R L7S L7T") },
  { name: "Oakville", prefixes: split("L6H L6J L6K L6L L6M") },
  { name: "Milton", prefixes: split("L9E L9T") },
  { name: "Mississauga", prefixes: split("L4T L4V L4W L4X L4Y L4Z L5A L5B L5C L5E L5G L5H L5J L5K L5L L5M L5N L5P L5R L5S L5T L5V L5W") },
  { name: "Brampton", prefixes: split("L4T L5P L6P L6R L6S L6T L6V L6W L6X L6Y L6Z L7A") },
  { name: "Caledon / Bolton", prefixes: split("L7C L7E") },
  { name: "Vaughan / Woodbridge / Concord / Maple / Kleinburg", prefixes: split("L4H L4J L4K L4L L6A L0J") },
  { name: "Richmond Hill", prefixes: split("L4B L4C L4E L4S") },
  { name: "Markham / Unionville / Thornhill", prefixes: split("L3P L3R L3S L3T L4B L4J L6B L6C L6E L6G") },
  { name: "Toronto – M1", prefixes: split("M1B M1C M1E M1G M1H M1J M1K M1L M1M M1N M1P M1R M1S M1T M1V M1W M1X") },
  { name: "Toronto – M2", prefixes: split("M2H M2J M2K M2L M2M M2N M2P M2R") },
  { name: "Toronto – M3", prefixes: split("M3A M3B M3C M3H M3J M3K M3L M3M M3N") },
  { name: "Toronto – M4", prefixes: split("M4A M4B M4C M4E M4G M4H M4J M4K M4L M4M M4N M4P M4R M4S M4T M4V M4W M4X M4Y") },
  { name: "Toronto – M5", prefixes: split("M5A M5B M5C M5E M5G M5H M5J M5K M5L M5M M5N M5P M5R M5S M5T M5V M5W M5X") },
  { name: "Toronto – M6", prefixes: split("M6A M6B M6C M6E M6G M6H M6J M6K M6L M6M M6N M6P M6R M6S") },
  { name: "Toronto – M8", prefixes: split("M8V M8W M8X M8Y M8Z") },
  { name: "Toronto – M9", prefixes: split("M9A M9B M9C M9L M9M M9N M9P M9R M9V M9W") },
  { name: "Pickering", prefixes: split("L1V L1W L1X L1Y") },
  { name: "Ajax", prefixes: split("L1S L1T L1Z") },
  { name: "Whitby / Brooklin", prefixes: split("L1M L1N L1P L1R") },
  { name: "Oshawa", prefixes: split("L1G L1H L1J L1K L1L") },
];

export const ALL_SERVICE_PREFIXES = Array.from(
  new Set(SERVICE_TERRITORIES.flatMap(territory => territory.prefixes))
);
